import Vue from 'vue'
import Vuex from 'vuex'
import defaultLocationData from '../data/default'

import mapInit from '../../global/mixins/gMapsInit'
import failAlert from "../../global/mixins/locationsListingFailAlert"

const isLocalTestingDomain = window.location.host.includes("localhost") || window.location.host.includes("ferrellgas-com-local-2022");

const state = {
	activeLocations: null,
	mapOptions: defaultLocationData.locationFinder.mapOptions,
	totalLocations: null,
	locationsPerPage: defaultLocationData.locationFinder.locationsPerPage,
	tags: [
		{
			name: "hasTankExchangeService",
			display: "Grill/RV Cylinder Service"
		},
		{
			name: "hasServiceRefuelingStation",
			display: "Autogas Refueling Station"
		}
	],
	lat: 38.930045,   // Default value to be used in first request if user location not enabled in browser
	lng: -94.673355,  // Default value to be used in first request if user location not enabled in browser
	page: null,
	activeTags: [],
	isLoading: true,
	requestEndpoint: null,
	// FG Key: AIzaSyC9b47pSej_k-nWaimFWo-uxfrw9MpV-PI -> the one that works
	// New FG Key: AIzaSyAD9QBtD4kAJUZs6ojhDhE9Iz4IzcKvh50 -> not working as of 7/22/2022
	// Test key for local dev - taken from Nick's Google dev account: AIzaSyAHe9G-GLf5nyIETswiq2h5Q0xHybCR_zk
	apiKey: isLocalTestingDomain ? "AIzaSyAHe9G-GLf5nyIETswiq2h5Q0xHybCR_zk" : "AIzaSyC9b47pSej_k-nWaimFWo-uxfrw9MpV-PI",
	google: null,
	map: null,
	googleInitialized: false,
	placesService: null,
	isLoadingMore: false
};
const getters = {
	activeLocations: state => state.activeLocations,
	mapOptions: state => state.mapOptions,
	totalLocations: state => state.totalLocations,
	locationsPerPage: state => state.locationsPerPage,
	tags: state => state.tags,
	activeTags: state => state.activeTags,
	lat: state => state.lat,
	lng: state => state.lng,
	page: state => state.page,
	isLoading: state => state.isLoading,
	isLoadingMore: state => state.isLoadingMore,
	apiKey: state => state.apiKey,
	google: state => state.google,
	map: state => state.map,
	googleInitialized: state => state.googleInitialized,
	placesService: state => state.placesService,
};
const mutations = {
	setStateValue(state, payload) {
		state[payload[0]] = payload[1];
	},
};
const actions = {
	async initGoogle({ state, commit }) {
		let newGoog = await mapInit(state.apiKey, true);
		commit('setStateValue', ['google', newGoog]);
		commit('setStateValue', ['googleInitialized', true]);
	},
	async sendLocationRequest({ state, commit }, payload) {
		let loadingMore = !payload || !payload[0] ? false : true;
		let skipFail = !payload || !payload[1] ? false : true;
		commit('setStateValue', ['isLoading', true]);
		if (loadingMore) commit('setStateValue', ['isLoadingMore', true]);
		let data = {
			lat: state.lat,
			lng: state.lng,
			tankExchangeServiceFilter: state.activeTags.includes("hasTankExchangeService"),
			serviceRefuelingStationFilter: state.activeTags.includes("hasServiceRefuelingStation")
		};
		if (state.page) data["page"] = state.page;
		await fetch(state.requestEndpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'accept': 'application/json'
			},
			body: JSON.stringify(data)
		}).then(response => response.json())
			.then(data => {
				// console.log(data)
				commit('setStateValue', ['activeLocations', data.locations]);
				commit('setStateValue', ['totalLocations', parseInt(data.totalLocations)]);
			});
		if (state.googleInitialized) {
			commit('setStateValue', ['isLoading', false]);
			commit('setStateValue', ['isLoadingMore', false]);
		}
		if ((state.activeLocations.length === 0 || state.totalLocations == 0) && !skipFail)	failAlert();
	},
};


export default {
	state,
	getters,
	mutations,
	actions
};